import React from "react";

export default function Four() {
  return (
    <div className="die-face fourth-face">
      <div className="column">
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
      <div className="column">
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );
}
